import { PopUp, openUrl } from "@fluidattacks/design";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { ILaptopModalFpProps } from "./types";

const LaptopModal: FC<ILaptopModalFpProps> = ({
  isOpen,
}): JSX.Element | null => {
  const { t } = useTranslation();

  if (isOpen) {
    return (
      <PopUp
        confirmButton={{
          onClick: (): void => {
            openUrl("https://fluidattacks.com/");
          },
          text: t("dashboard.minimumWidth.button"),
        }}
        darkBackground={true}
        description={t("dashboard.minimumWidth.description2")}
        image={{
          alt: "viewMobileError",
          height: "175px",
          src: "integrates/resources/mobile",
          width: "100%",
        }}
        mobile={true}
        title={t("dashboard.minimumWidth.title")}
      />
    );
  }

  return null;
};

export { LaptopModal };
